if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
          openPopup: ".js-sticky-atc-confirm",
          closePopup: ["[data-close-popup]"],
          popup: ".m-sticky-atc-popup",
        };
        this.hasCustomFields = !!document.querySelector(
          ".m-main-product--info .m-product-custom-field",
        );
      }

      connectedCallback() {
        console.log("mainProduct", this.mainProduct);
        console.log("mainProductForm", this.mainProductForm);
        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']",
        );
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainAddToCart = document.querySelector(
          '.m-product-form--main [name="add"]',
        );
        if (!this.mainAddToCart) {
          this.mainAddToCart = document.querySelector(
            '.m-main-product--info [name="add"]',
          );
        }
        // this.mainDynamicCheckout = this.mainProductForm.querySelector(
        //   this.selectors.buyNowBtn,
        // );
        this.mainDynamicCheckout = this.mainProductForm
          ? this.mainProductForm.querySelector(this.selectors.buyNowBtn)
          : null;

        this.disableSelectedVariantDefault =
          (this.mainProduct && this.mainProduct.dataset.disableSelectedVariantDefault === "true") ||
          false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        this.variantData = this.getVariantData();
        console.log("stickyBar", this.closest(".m-sticky-addtocart"));
        const stickyBar = this.closest(".m-sticky-addtocart");
        if (stickyBar) {
          stickyBar.style.setProperty("--m-translate-y", "100%");
        }

        const handleScroll = () => {
          const scrollPos = window.scrollY;
          const threshold = 10;

          if (!stickyBar) return;

          if (scrollPos > threshold) {
            if (!document.documentElement.classList.contains("stick-atc-show")) {
              if (typeof jdgm !== "undefined" && typeof jdgm.refreshWidgets === "function") {
                jdgm.refreshWidgets();
              }
            }
            stickyBar.style.setProperty("--m-translate-y", "0");
            document.documentElement.classList.add("stick-atc-show");
          } else {
            stickyBar.style.setProperty("--m-translate-y", "100%");
            document.documentElement.classList.remove("stick-atc-show");
          }
        };


        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Check immediately to set correct state




        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        prodTitle.addEventListener("click", () => __scrollToTop());
        mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();

        this.setObserveTarget();
        this.syncWithMainProductForm();
        this.syncVariantPickers();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();

        this.domNodes.select.addEventListener("change", (e) => {
          const { target } = e;
          const variantPicker =
            this.mainProduct ? this.mainProduct.querySelector("variant-picker") : null;
          const selectedVariantId = this.querySelector(
            this.selectors.variantIdSelect,
          ).value;
          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId),
          );
          this.currentVariant
            ? this.toggleAddButton(
              !this.currentVariant.available,
              window.MinimogStrings.soldOut,
            )
            : (this.isVariantUnselected()
              ? this.toggleAddButton(false, window.MinimogStrings.addToCart)
              : this.toggleAddButton(true, window.MinimogStrings.unavailable)
            );

          const selectedOption = target.options[target.selectedIndex];
          const selectedOptionIds = selectedOption.dataset.options
            .split(",")
            .filter((id) => id);

          if (variantPicker) {
            selectedOptionIds.forEach((optionId) => {
              const input = variantPicker.querySelector(
                `[data-option-value-id="${optionId}"]`,
              );
              const { tagName } = input;
              switch (tagName) {
                case "OPTION":
                  const inputParent = input.parentNode; // select tag
                  inputParent.value = input.value;
                  break;
                case "INPUT":
                  input.checked = true;
                  break;
              }
            });
            variantPicker.dispatchEvent(new Event("change"));
          }
        });

        const { openPopup, closePopup, popup } = this.domNodes;

        if (openPopup && popup) {
          const targetPopup = popup.length ? popup[0] : popup;
          const openBtns = openPopup.length ? Array.from(openPopup) : [openPopup];

          const togglePopup = (forceClose = false) => {
            const isClosing = forceClose || targetPopup.classList.contains("open");

            targetPopup.classList.toggle("open", !isClosing);
            document.body.classList.toggle("m-sticky-atc-popup-open", !isClosing);

            if (isClosing) {
              openBtns.forEach((ob) => {
                ob.classList.remove("is-changed");
                ob.textContent = "customise";
              });
            }
          };

          openBtns.forEach((btn) => {
            btn.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              togglePopup();
            }, true);
          });

          if (closePopup) {
            closePopup.forEach((btn) => btn.addEventListener("click", () => togglePopup(true)));
          }
        }
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector('[type="application/json"]')
              .textContent,
          );
        return this.variantData;
      }

      setObserveTarget() {
        // No longer using IntersectionObserver for main visibility
      }

      isVariantUnselected() {
        const variantPicker = this.querySelector('variant-picker');
        if (!variantPicker) {
          const idSelect = this.querySelector('select[name="id"]');
          if (idSelect && !idSelect.classList.contains('m:hidden')) {
            return idSelect.value === "";
          }
          return false;
        }

        if (variantPicker.dataset.hasOnlyDefaultVariant === "true") {
          return false;
        }

        const pickerFields = variantPicker.querySelectorAll('[data-picker-field]');
        for (let field of pickerFields) {
          const val = field.dataset.selectedValue || "";
          if (val.trim() === "") {
            return true;
          }

          const select = field.querySelector('select');
          if (select && select.value === "") {
            return true;
          }

          if (field.dataset.pickerField === "radio") {
            const checked = field.querySelector('input:checked');
            if (!checked) {
              return true;
            }
          }
        }
        return false;
      }

      setUnavailable() {
        if (this.isVariantUnselected()) {
          this.toggleAddButton(false, window.MinimogStrings.addToCart);
        } else {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForms = this.querySelectorAll(".m-product-form");
        if (!productForms.length) return;

        productForms.forEach((productForm) => {
          const addButton = productForm.querySelector('[name="add"]');
          const addButtonText = productForm.querySelector(
            '[name="add"] > span.m-add-to-cart--text',
          );
          if (!addButton) return;

          if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute("disabled");
            addButtonText.innerHTML = window.MinimogStrings.addToCart;
          }
        });

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        // Clear select[name="id"] dropdown
        const selectId = this.querySelector('select[name="id"]');
        if (selectId) selectId.value = "";

        const pickerFields = this.querySelectorAll("[data-picker-field]");
        pickerFields.forEach((field) => {
          let pickerType = field.dataset.pickerField;
          switch (pickerType) {
            case "select":
              let selectBox = field.querySelector("select");
              if (selectBox) {
                // If it doesn't have the disabled select option already, add it
                let hasDefault = Array.from(selectBox.options).some(opt => opt.value === "" && opt.disabled);
                if (!hasDefault && this.mainProduct) {
                  let option = document.createElement("option");
                  option.text = this.mainProduct.dataset.variantOptionNoneText || "Select option";
                  option.setAttribute("disabled", "");
                  option.setAttribute("selected", "");
                  selectBox.add(option, 0);
                }
                selectBox.value = "";
              }
              break;
            default:
              let checkedInputs = field.querySelectorAll("input:checked");
              checkedInputs &&
                checkedInputs.forEach(function (input) {
                  input.removeAttribute("checked");
                  input.checked = false;
                });
              break;
          }

          field.dataset.selectedValue = "";
          if (field.querySelector(".option-label--selected")) {
            field.querySelector(".option-label--selected").textContent = "";
          }
        });

        const variantInputs = this.querySelectorAll('[name="id"]');
        variantInputs.forEach((input) => {
          input.value = "";
          if (input.tagName === "SELECT") {
            input.selectedIndex = 0;
          }
        });

        this.setUnavailable();
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty(
          "--f-sticky-atc-bar-height",
          this.offsetHeight + "px",
        );
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      syncWithMainProductForm() {
        const variantInputs = this.querySelectorAll('[name="id"]');
        MinimogEvents.subscribe(
          MinimogTheme.pubSubEvents.variantChange,
          (e) => {
            const isMainProduct =
              this.mainProduct && e.data.sectionId === this.mainProduct.dataset.sectionId;
            if (!isMainProduct) return;
            this.currentVariant = e.data.variant;
            if (this.currentVariant) {
              variantInputs.forEach(
                (input) => (input.value = e.data.variant.id),
              );
              this.toggleAddButton(
                !this.currentVariant.available,
                window.MinimogStrings.soldOut,
              );
              this.updateVariantSummary(this.currentVariant);
            } else {
              variantInputs.forEach((input) => (input.value = ""));
              if (this.isVariantUnselected()) {
                this.toggleAddButton(false, window.MinimogStrings.addToCart);
              } else {
                this.toggleAddButton(true, window.MinimogStrings.unavailable);
              }
            }

            if (e.data.html) {
              const newStickyAtc = e.data.html.querySelector("sticky-atc");
              if (newStickyAtc) {
                const newColorWrappers = newStickyAtc.querySelectorAll(
                  ".color-variant-wrapper-block",
                );
                const currentColorWrappers = this.querySelectorAll(
                  ".color-variant-wrapper-block",
                );
                if (newColorWrappers.length && currentColorWrappers.length) {
                  currentColorWrappers.forEach((wrapper, index) => {
                    if (newColorWrappers[index]) {
                      wrapper.innerHTML = newColorWrappers[index].innerHTML;
                    }
                  });
                } else {
                  const newVariantPickers =
                    newStickyAtc.querySelectorAll("variant-picker");
                  const currentVariantPickers =
                    this.querySelectorAll("variant-picker");
                  if (
                    newVariantPickers.length &&
                    currentVariantPickers.length
                  ) {
                    currentVariantPickers.forEach((current, index) => {
                      if (newVariantPickers[index]) {
                        current.innerHTML = newVariantPickers[index].innerHTML;
                      }
                    });
                  }
                }
              }
            }
          },
        );
      }

      syncVariantPickers() {
        const variantPickers = this.querySelectorAll("variant-picker");
        if (variantPickers.length < 2) return;

        MinimogEvents.subscribe(
          MinimogTheme.pubSubEvents.optionValueSelectionChange,
          (e) => {
            const { selectedOptionValues, target } = e.data;
            if (!this.contains(target)) return;

            variantPickers.forEach((picker) => {
              if (picker.contains(target)) return;

              selectedOptionValues.forEach((valueId) => {
                const input = picker.querySelector(
                  `[data-option-value-id="${valueId}"]`,
                );
                if (input) {
                  if (input.tagName === "INPUT") {
                    input.checked = true;
                  } else if (input.tagName === "OPTION") {
                    input.selected = true;
                    input.parentNode.value = input.value;
                  }
                }
              });
            });
          },
        );
      }

      updateVariantSummary(variant) {
        if (!variant) return;
        const summary = this.querySelector(
          ".m-sticky-addtocart--variant-summary",
        );
        const openPopupBtn = this.querySelector(this.selectors.openPopup);

        if (openPopupBtn) {
          openPopupBtn.classList.add("is-changed");
          openPopupBtn.textContent = "confirm";
        }

        if (!summary) return;

        variant.options.forEach((optionValue, index) => {
          const valueElement = summary.querySelector(
            `[data-index="${index}"] .m-sticky-addtocart--variant-option-value`,
          );
          if (valueElement) valueElement.textContent = optionValue;
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(
          ".m-main-product--info .m-product-custom-field",
        );
        let customFieldFirst = customFields[0];
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () =>
              this.mainAddToCart.click(),
            );
          });
        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () =>
                  this.mainDynamicCheckout.click(),
                );
              }
            },
            true,
          );
        }
        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () =>
              this.mainAddToCart.click(),
            );
          });
        }
      }
    },
  );
}
